// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__UIrO7","footerActions":"styles_footerActions__2NAPo"};